import * as React from "react";
import cn from "classnames";
import styles from "./AppButton.module.scss";

export type AppButtonVariant =
  | "yellow"
  | "siren"
  | "gray"
  | "siren_border"
  | "siren_dashed_border"
  | "red";
interface Props {
  variant?: AppButtonVariant;
  size?: "small" | "normal";
}

export const AppButton: React.FC<
  Props & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ variant = "yellow", size = "normal", ...props }) => {
  const variantClassName = {
    yellow: styles.button__yellow,
    siren: styles.button__siren,
    gray: styles.button__gray,
    siren_border: styles.button__siren_border,
    siren_dashed_border: styles.button__siren_dashed_border,
    red: styles.button__red,
  };

  const sizeClassName = {
    small: styles.button__size__small,
    normal: null,
  };
  return (
    <button
      className={cn(
        styles.button,
        variantClassName[variant],
        sizeClassName[size]
      )}
      {...props}
    />
  );
};
